<main class="mb-4" *ngIf="isCommonDataLoaded">
  <div class="row">
    <div class="col-sm-12">
      <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Title' | translate}}</h2>
    </div>
  </div>

  <div class="row">
    <!-- Número de subscritor -->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="subscriberNumber" class="disabled">
          <span class="mandatory">*</span>
          {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.SubscriberNumber' | translate}}
        </label>
        <div class="position-relative">
          <input class="form-control input-right"
                 type="number"
                 [(ngModel)]="cardData.subscriberNumber"
                 #subscriberNumber="ngModel"
                 name="subscriberNumber"
                 placeholder="{{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.SubscriberNumberPlaceholder' | translate}}"
                 messageFieldType="string" disabled>

          <validation-message [control]="subscriberNumber"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Nome -->
    <div class="col-sm-8">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('subscriberName')">
          <label for="name" [ngClass]="{'disabled': isFieldDisabled('subscriberName')}" >
            <span  class="mandatory">*</span>
            {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.Name' | translate}}
          </label>
          <div class="position-relative">
            <input class="form-control input-right"
                   type="text"
                   [(ngModel)]="cardData.subscriberName"
                   #name="ngModel"
                    maxlength="60"
                   name="name"
                   placeholder="{{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.NamePlaceholder' | translate}}"
                   required messageFieldType="string"
                   />
            <validation-message [control]="name"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

    <!-- Data de nascimento -->
    <div class="col-sm-4">
      <div class="form-group">
        <div class="form-row" *ngIf="isFieldDisabled('dateOfBirth')">
          
            <label for="dateOfBirth" style="margin-left:5px" class="disabled">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.DateOfBirth' | translate}}
            </label>
            <div class="input-group col-sm-12">
              <input type="text"
                     class="form-control DatepickerCustomClasse"
                     [value]="getMaskDate(cardData.dateOfBirth)"
                     name="dateOfBirth"
                     readonly
                     required
                     disabled/>
              <div class="input-group-append disable-on-fieldset">
                <span class="input-group-text" id="basic-addon2">
                  <i class="icon-calendar"></i>
                </span>
              </div>
              <div class="invalid-feedback"></div>
            </div>
        </div>
        <div class="form-row" *ngIf="!isFieldDisabled('dateOfBirth')">
    
            <label for="dateOfBirth">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.DateOfBirth' | translate}}
            </label>
            <div class="form-row">
              <div class="input-group col-sm-12">
                <input #dpDateOfBirth="bsDatepicker"
                       bsDatepicker
                       type="text"
                       autocomplete="off"
                       class="form-control DatepickerCustomClasse"
                       placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                       [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                       [(ngModel)]="cardData.dateOfBirth"
                       name="dateOfBirth"
                       maxlength="10"
                       required
                       readonly
                       #dateOfBirth="ngModel"
                       (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)"/>
                <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfBirth.isDisabled && dpDateOfBirth.toggle()">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="icon-calendar"></i>
                  </span>
                </div>
                <validation-message [control]="dateOfBirth"></validation-message>
              </div>
            </div>

        </div>  
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Tipo de documento de identificação -->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="identificationDocumentType" [ngClass]="{'disabled': isFieldDisabled('identificationDocumentType')}">
          <span  class="mandatory">*</span>
          {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.IdentificationDocumentType' | translate}}
        </label>
        <select class="custom-select"
                [(ngModel)]="cardData.identificationDocumentType"
                name="identificationDocumentType"
                #identificationDocumentType="ngModel"
                [dropdownTitle]="{value : cardData.identificationDocumentType, dimensions : documentTypes }"
                nullableSelect
                [disabled]="isFieldDisabled('identificationDocumentType')">
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of documentTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="identificationDocumentType"></validation-message>
      </div>
    </div>

    <!-- Número de identificação -->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset disabled *ngIf="isFieldDisabled('identificationNumberFirst')">

          <label for="IdentificationNumber" [ngClass]="{'disabled': isFieldDisabled('identificationNumberFirst')}">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.IdentificationNumber' | translate}}
          </label>
          <div class="form-row">

            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="cardData.identificationNumberFirst"
                     name="identificationNumberFirst"
                     required disabled />
              <validation-message [control]="identificationNumberFirst"></validation-message>
            </div>
            <div class="col-sm-3">
              <input class="form-control" type="text" [(ngModel)]="cardData.identificationNumberLast"
                     name="identificationNumberLast" disabled>
            </div>


          </div>
        </fieldset>
        <fieldset  *ngIf="!isFieldDisabled('identificationNumberFirst')">

          <label  for="IdentificationNumber">
            <span class="mandatory">*</span> {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.IdentificationNumber' | translate}}
          </label>
          <div class="form-row">
            @if(cardData.identificationDocumentType !='P' ){
            <div class="col-sm-9">
              <input class="form-control"
                     type="text"
                     required
                     numeric="8"
                     [(ngModel)]="cardData.identificationNumberFirst"
                     name="identificationNumberFirst"
                     #identificationNumberFirst="ngModel"
                     maxlength="8" />
              <validation-message [control]="identificationNumberFirst"></validation-message>
            </div>
            } @else {
            <div class="col-sm-9">
              <input class="form-control"
                     type="text"
                     mask="A*"
                     required
                     [(ngModel)]="cardData.identificationNumberFirst"
                     name="identificationNumberFirst"
                     #identificationNumberFirst="ngModel"
                     maxlength="10" />
              <validation-message [control]="identificationNumberFirst"></validation-message>
            </div>
            }
            <!--<div class="col-sm-9">
              <input class="form-control" type="text" [(ngModel)]="cardData.identificationNumberFirst"
                     name="identificationNumberFirst"
                     #identificationNumberFirst="ngModel"
                     maxlength="10"
                     required />
              <validation-message [control]="identificationNumberFirst"></validation-message>
            </div>-->
            <div class="col-sm-3">
              <input class="form-control" type="text" maxlength="4" [(ngModel)]="cardData.identificationNumberLast"
                     name="identificationNumberLast">
            </div>


          </div>
        </fieldset>

      </div>
    </div>

    <!-- NIF -->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="nif" [ngClass]="{'disabled': isFieldDisabled('nif')}">
          <span  class="mandatory">*</span>
          {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.NIF' | translate}}
        </label>
        <input class="form-control"
               type="text"
               [value]="getMaskNumber(cardData.NIF)"
               name="nif"
               required
               readonly
               disabled />
        <div class="invalid-feedback"></div>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Estado cívil -->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="MaritalStatus" [ngClass]="{'disabled': isFieldDisabled('maritalStatus')}">
         <span class="mandatory">*</span>
         {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.MaritalStatus' | translate}}
        </label>
        <ng-context *ngIf="isFieldDisabled('maritalStatus'); else maritalStatusEditable" >
          <input class="form-control"
                 type="text"
                 [value]="getMaskMaritalStatus(cardData.maritalStatus)"
                 name="MaritalStatus"
                 required
                 readonly
                 disabled />
          <div class="invalid-feedback"></div>
        </ng-context>
        <ng-template #maritalStatusEditable>
          <select class="custom-select"
                  [(ngModel)]="cardData.maritalStatus"
                  name="maritalStatus"
                  #maritalStatus="ngModel"
                  required
             
                  nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of maritalStatusTypes" [value]="domain.description">
              {{domain.value}}
            </option>
          </select>
          <validation-message [control]="maritalStatus"></validation-message>
        </ng-template>
        
      </div>
    </div>

    <!-- Nome do pai -->
    <div class="col-sm-8">
      <div class="form-group">
        <label for="fatherName" [ngClass]="{'disabled': isFieldDisabled('fatherName')}">
        <span  class="mandatory">*</span>
        {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.FatherName' | translate}}</label>
        <div class="position-relative">
          <input class="form-control input-right"
                 type="text"
                 [(ngModel)]="cardData.fatherName"
                 #fatherName="ngModel"
                  maxlength="60"
                 name="fatherName"
                 placeholder="{{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.FatherNamePlaceholder' | translate}}"
                 required
                 messageFieldType="string"
                 [disabled]="isFieldDisabled('fatherName')">
          <validation-message [control]="fatherName"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Nome da mãe-->
    <div class="col-sm-8">
      <div class="form-group">
        <label for="motherName" [ngClass]="{'disabled': isFieldDisabled('motherName')}">
          <span  class="mandatory">*</span>
          {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.MotherName' | translate}}
        </label>
        <div class="position-relative">
          <input class="form-control input-right"
                 type="text"
                 [(ngModel)]="cardData.motherName"
                 #motherName="ngModel"
                  maxlength="60"
                 name="motherName"
                 placeholder="{{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.MotherNamePlaceholder' | translate}}"
                 required
                 messageFieldType="string"
                 [disabled]="isFieldDisabled('motherName')">
          <validation-message [control]="motherName"></validation-message>
        </div>
      </div>
    </div>

    <!-- Data de falecimento -->
    <div class="col-sm-4">
      <div class="form-group">
        <div class="form-row" *ngIf="!isFieldDisabled('deathDate')">
          <label for="deathDate" [ngClass]="{'disabled':isFieldDisabled('deathDate')}" style="margin-left:5px">
            <span  class="mandatory">*</span>
            {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.DeathDate' | translate}}
          </label>
          <div class="input-group col-sm-12">
            <input #dpDateOfDeath="bsDatepicker"
                   bsDatepicker
                   type="text"
                   autocomplete="off"
                   class="form-control DatepickerCustomClasse"
                   placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                   [(ngModel)]="cardData.deathDate"
                   name="deathDate"
                   [minDate]="minDate"
                   [maxDate]="maxDate"
                   [clearRelated]="{model : this.cardData , propsToReset : [ 'diagnosedDeathDate','deathDateRegistered']}"

                   maxlength="10"
                   readonly
                   #deathDate="ngModel"
                   required
                   [disabled]="isFieldDisabled('deathDate')"
                   (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpDateOfDeath)"/>
            <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfDeath.isDisabled && dpDateOfDeath.toggle()">
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <validation-message [control]="deathDate"></validation-message>
          </div>
        </div>
        <div class="form-row" *ngIf="isFieldDisabled('deathDate')">
          <label for="deathDate" [ngClass]="{'disabled':isFieldDisabled('deathDate')}" style="margin-left:5px">
            <span *ngIf="isFieldDisabled('deathDate')" class="mandatory">*</span> {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.DeathDate' | translate}}
          </label>
          <div class="input-group col-sm-12">
            <input 
                   type="text"
                   autocomplete="off"
                   class="form-control DatepickerCustomClasse"
                   [value]="getMaskDate(cardData.deathDate)"
                   name="deathDate"
                   maxlength="10"

                   readonly
                   required
                   disabled />
            <div class="input-group-append disable-on-fieldset" >
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <validation-message [control]="deathDate"></validation-message>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">

    <!-- Data do registo de falecimento -->
    <div class="col-sm-4">
      <div class="form-group">
        <div class="form-row">
          <label for="deathDateRegistered" [ngClass]="{'disabled': isFieldDisabled('deathDateRegistered')}" style="margin-left:5px">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.DeathDateRegistration' | translate}}
          </label>
          <div class="input-group col-sm-12">
            <input #dpDateOfDeathRegistration="bsDatepicker"
                   bsDatepicker
                   type="text"
                   autocomplete="off"
                   class="form-control DatepickerCustomClasse"
                   placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                   [(ngModel)]="cardData.deathDateRegistered"
                   name="deathDateRegistered"
                   [minDate]="cardData.deathDate"
                   [maxDate]="maxDate"
                   maxlength="10"
                   readonly
                   #deathDateRegistered="ngModel"
                   required
                   [disabled]="isFieldDisabled('deathDateRegistered')"
                   (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpDateOfDeathRegistration)" />
            <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfDeathRegistration.isDisabled && dpDateOfDeathRegistration.toggle()">
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <validation-message [control]="deathDateRegistered"></validation-message>
          </div>
        </div>
      </div>
    </div>

    <!-- Causa da morte -->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="deathCause"><span class="mandatory">*</span> {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.DeathCause' | translate}}</label>
        <select class="custom-select"
                [(ngModel)]="cardData.deathCause"
                name="deathCause"
                #deathCause="ngModel"
                required
                nullableSelect
                [clearRelated]="{model : this.cardData , propsToReset : ['deathCauseDetail', 'diagnosedDeathDate']}">
          >
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let dropdown of dropListCauseOfDeath" [value]="dropdown.value">
            {{dropdown.description}}
          </option>
        </select>
        <validation-message [control]="deathCause"></validation-message>
      </div>
    </div>

    <!-- Detalhe da causa da morte -->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="motherName" [ngClass]="{'disabled': (cardData.deathCause !==causeOfDeathValues.Doenca && cardData.deathCause !==causeOfDeathValues.Outra)}">
          <span *ngIf=" cardData.deathCause ==causeOfDeathValues.Outra" class="mandatory">*</span>
          {{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.DeathCauseDetail' | translate}}
        </label>
        <div class="position-relative">
          <input class="form-control input-right"
                 type="text"
                 [(ngModel)]="cardData.deathCauseDetail"
                 #deathCauseDetail="ngModel"
                 name="deathCauseDetail"
                 [disabled]="(cardData.deathCause !==causeOfDeathValues.Doenca && cardData.deathCause !==causeOfDeathValues.Outra)"
                 placeholder="{{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.DeathCauseDetailPlaceholder' | translate}}"
                 [required]=" cardData.deathCause ==causeOfDeathValues.Outra"
                 messageFieldType="string">
          <!--<ng-content *ngIf="(cardData.deathCause ==causeOfDeathValues.Doenca || cardData.deathCause ==causeOfDeathValues.Outra); else vmCauseOfDeathDetail">
          <validation-message [control]="cardData.deathCauseDetail" [message]="'ValidationMessages.required' | translate"></validation-message>
        </ng-content>
        <ng-template #vmCauseOfDeathDetail>
          <validation-message [control]="cardData.deathCauseDetail" [message]="' '"></validation-message>
        </ng-template>-->
          <validation-message [control]="deathCauseDetail"></validation-message>
        </div>
      </div>
    </div>
  
  </div>

  <div class="row">

    <!-- Data do registo de falecimento -->
    <div class="col-sm-4">
      <div class="form-group">
        <div class="form-row">
          <label for="diagnosedDeathDate" [ngClass]="{'disabled': (cardData.deathCause !==causeOfDeathValues.Acidente && cardData.deathCause !==causeOfDeathValues.AcidenteEmServico && cardData.deathCause !==causeOfDeathValues.Doenca && cardData.deathCause !==causeOfDeathValues.DoencaProfissional)}" style="margin-left:5px"><span *ngIf="!(cardData.deathCause !==causeOfDeathValues.Acidente && cardData.deathCause !==causeOfDeathValues.AcidenteEmServico && cardData.deathCause !==causeOfDeathValues.Doenca && cardData.deathCause !==causeOfDeathValues.DoencaProfissional)" class="mandatory">*</span>{{'PrestacoesMorte.StepDeceased.Cards.DeceasedIdentification.Fields.DiagnosedDeathDate' | translate}}</label>
          <div class="input-group col-sm-12">
            <input #dpDiagnosedDeathDate="bsDatepicker"
                   bsDatepicker
                   type="text"
                   autocomplete="off"
                   class="form-control DatepickerCustomClasse"
                   placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                   [(ngModel)]="cardData.diagnosedDeathDate"
                   [minDate]="minDate"
                   [maxDate]="cardData.deathDate"
                   name="diagnosedDeathDate"
                   maxlength="10"
                   readonly
                   #diagnosedDeathDate="ngModel"
                   [disabled]="(cardData.deathCause !==causeOfDeathValues.Acidente && cardData.deathCause !==causeOfDeathValues.AcidenteEmServico && cardData.deathCause !==causeOfDeathValues.Doenca && cardData.deathCause !==causeOfDeathValues.DoencaProfissional)"
                   [required]="(cardData.deathCause ==causeOfDeathValues.Acidente || cardData.deathCause ==causeOfDeathValues.AcidenteEmServico || cardData.deathCause ==causeOfDeathValues.Doenca || cardData.deathCause ==causeOfDeathValues.DoencaProfissional)"
                   (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpDiagnosedDeathDate)" />
            <div class="input-group-append disable-on-fieldset" (click)="!dpDiagnosedDeathDate.isDisabled && dpDiagnosedDeathDate.toggle()">
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <!--<ng-content *ngIf="(cardData.deathCause ==causeOfDeathValues.Acidente || cardData.deathCause ==causeOfDeathValues.AcidenteEmServico || cardData.deathCause ==causeOfDeathValues.Doenca || cardData.deathCause ==causeOfDeathValues.DoencaProfissional); else vmDiagnosedDeathDate">
              <validation-message [control]="cardData.diagnosedDeathDate" [message]="'ValidationMessages.required' | translate"></validation-message>
            </ng-content>
            <ng-template #vmDiagnosedDeathDate>
              <validation-message [control]="cardData.diagnosedDeathDate" [message]="' '"></validation-message>
            </ng-template>-->
            <validation-message [control]="diagnosedDeathDate" ></validation-message>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
